import React from 'react'

import { Country } from '@cash-web/protos/squareup/common/countries.pb'

import { useAuth } from './hooks/useAuth'

// Reads useAuth().profile inline to avoid a cycle with @cash-web/shared-data-access-core-profile.
// The forthcoming lint rule that blocks useAuth().profile usage exempts internal consumers
// inside this lib.
export const useRedirectNonUsCustomerTo = (href: string) => {
  const profileCountry = useAuth().profile?.country_code

  React.useEffect(() => {
    if (profileCountry !== undefined && profileCountry !== Country.US) {
      window.location.href = href
    }
  }, [profileCountry, href])
}

export const useRedirectIfNotInSupportedCountries = ({
  href,
  supportedCountries,
}: {
  href: string
  supportedCountries: ReadonlyArray<Country | string>
}) => {
  const profileCountry = useAuth().profile?.country_code

  React.useEffect(() => {
    if (profileCountry !== undefined && !supportedCountries.some(country => country === profileCountry)) {
      window.location.href = href
    }
  }, [profileCountry, href, supportedCountries])
}
